import { createSearch } from '@/apis/searches';
import { queryClient } from '@/App';
import { SearchType } from '@/types';
import { useSaladBar } from '@australiangreens/ag-internal-components';
import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';

export const useSaveSearch = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { enqueueSuccessNotification } = useSaladBar();
  return useMutation({
    mutationFn: async (vars: {
      name: string;
      assignedToSubs: string[];
      description: string;
      searchType: SearchType;
      searchJson: string;
      savedBySub: string;
    }) => {
      return createSearch(await getAccessTokenSilently(), vars);
    },
    onSuccess: () => {
      enqueueSuccessNotification('The search has been saved');
      queryClient.invalidateQueries({ queryKey: ['searches'] });
    },
  });
};
